<template>
  <div :class="`form-group ${error ? 'has-error' : ''}`">
    <label class="control-label">{{ label }}</label>
    <br/>
    <input
      :id="id || 'c-uploader'"
      role="uploadcare-uploader"
      type="hidden"
      v-bind="$attrs"
      ref="input"
    />
    <br/>
    <span>{{fileName}}</span>
    <!--    <Uploadcare-->
    <!--        publicKey="0b4ce297590920c2697a"-->
    <!--        v-bind="$attrs"-->
    <!--        @success="uploadFile"-->
    <!--        @error="onError"-->
    <!--    >-->
    <!--            <button :class="`btn ${error ? 'btn-danger' : 'btn-primary'}`">{{ buttonText || 'Upload' }}</button>-->
    <!--    </Uploadcare>-->
    <small class="text-danger" v-if="error">
      {{ error }}
    </small>
    <span class="help-block" v-if="help">{{ help }}</span>
  </div>
</template>

<!--<style>-->
<!--.uploadcare&#45;&#45;widget__button.uploadcare&#45;&#45;widget__button_type_open {-->
<!--  background-color: var(&#45;&#45;bg-color);-->
<!--}-->
<!--</style>-->

<script>
// import Uploadcare from "uploadcare-vue";

export default {
  props: [
    'label',
    'buttonText',
    'onSuccess',
    'onError',
    'error',
    'help',
    'id',
    'theme'
  ],
  data(){
    return {
      fileName: '',
    }
  },
  // components: {
  //   Uploadcare,
  // },:style="cssProps"
  // computed: {
  //   cssProps() {
  //     return {
  //       '--bg-color': (() => {
  //         switch(this.theme){
  //           case 'primary':
  //             return '#4D90FD';
  //           case 'success':
  //             return '#8dbd5f'
  //           case 'danger':
  //             return '#d9534f'
  //           case 'info':
  //             return '#5bc0de'
  //           case 'warning':
  //             return '#f0ad4e'
  //           default :
  //             return '#4D90FD'
  //         }
  //
  //         return '#4D90FD'
  //       })() || '#4D90FD',
  //     }
  //   }
  // },
  mounted() {
    const self = this
    uploadcare.Widget(this.$refs.input).onChange((file) => {
      if (file) {
        file.done((fileInfo) => {
          self.fileName = fileInfo.name
          // self.onSuccess(fileInfo)
          self.$emit('onSuccess', fileInfo)

          uploadcare.Widget(this.$refs.input).value(null)
        })
      }
    })
  },
  methods: {
    // uploadFile: (file) => {
    //   console.log("file",file)
    //   this.$emit('onSuccess', file)
    // }
  }
}
</script>
